import { Environment } from './enviroment.interface';

export const environment: Environment = {
  production: true,
  apiPath: 'https://test.api.co2.dav-hersbruck.de',
  baseUrl: 'https://test.co2.dav-hersbruck.de',
};
